import { createContext, useContext, useSyncExternalStore } from "react";
import type { BillBookStore } from "./bill-book.ts";
import type { BillBook } from "./bills.ts";

/**
 * The open bills, as React sees it.
 *
 * Same shape as `useTill` and for the same reason: the book outlives every
 * screen, because a service does.
 */

export const BillBookContext = createContext<BillBookStore | null>(null);

export function useBills(): { bills: BillBookStore; book: BillBook } {
  const bills = useContext(BillBookContext);
  if (!bills) throw new Error("useBills must be used inside a BillBookProvider");

  const book = useSyncExternalStore(
    (listener) => bills.subscribe(listener),
    () => bills.book(),
    () => bills.book(),
  );

  return { bills, book };
}
